import { AlertReason } from "../models/entities/alert.model";
import { ITablePagination } from "../models/components/table/table-pagination.model";
import { BackendPagination } from "../models/pagination.model";
import {
	MY_ALERTS_QUERY_KEYS,
	MY_ALERTS_PAGE_SIZE,
	MY_ALERTS_DEFAULT_PAGINATION,
	buildMyAlertsPagination,
	UseMyAlertsResult,
	useMyAlerts,
} from "./useMyAlerts";

/**
 * Backward-compatible exports for critical alerts (use useMyAlerts directly for other reasons).
 */
export const MY_CRITICAL_ALERTS_QUERY_KEYS = MY_ALERTS_QUERY_KEYS;
export const MY_CRITICAL_ALERTS_PAGE_SIZE = MY_ALERTS_PAGE_SIZE;
export const MY_CRITICAL_ALERTS_DEFAULT_PAGINATION = MY_ALERTS_DEFAULT_PAGINATION;

export const buildMyCriticalAlertsPagination = (
	assigneeId: number,
	pagination?: Partial<ITablePagination>
): BackendPagination =>
	buildMyAlertsPagination(assigneeId, AlertReason.CRITICAL_READING, pagination);

export type UseMyCriticalAlertsResult = UseMyAlertsResult;

export const useMyCriticalAlerts = (
	assigneeId: number | undefined | null
): UseMyCriticalAlertsResult => useMyAlerts(assigneeId, AlertReason.CRITICAL_READING);
